import { Box } from '@mui/material'

// Types
import type { SoonBadgeProps } from '@/types/components/atoms/badge'

// Small warm pill for features that are still being finished ("in the oven")
const SoonBadgeAtom = (props: SoonBadgeProps) => {
	// Props
	const { label } = props

	return (
		<Box
			component="span"
			sx={{
				display: 'inline-flex',
				alignItems: 'center',
				flexShrink: 0,
				px: 1,
				py: 0.25,
				borderRadius: 999,
				fontSize: 11,
				fontWeight: 700,
				lineHeight: 1.6,
				whiteSpace: 'nowrap',
				color: '#7a5a1e',
				bgcolor: '#f6ecd8'
			}}
		>
			{label}
		</Box>
	)
}

export default SoonBadgeAtom
